export const prepareBooleanStringFeatureFlag = (value, defaultValue) => {
    if (!value) {
        return defaultValue;
    }
    return value === 'true';
};
export const prepareNumberStringFeatureFlag = (value, defaultValue) => {
    if (value) {
        return parseInt(value, 10);
    }
    return defaultValue;
};
//# sourceMappingURL=feature-flags.util.js.map